import React from 'react';
import ReactDOM from 'react-dom';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

import isEmail from 'validator/lib/isEmail';

import '../chapter3/toBlob_polyfill';

import NoteIntro from '../noteintro';
import ArtworkIntro from '../chapter3/artwork-intro';
import ArtworkSubmit from '../chapter3/artwork-submit';
import ArtworkUpload from '../chapter3/artwork-upload';
import ArtworkThanks from '../chapter3/artwork-thanks';

import ArtworkMobileShare from '../chapter3/artwork-mobile-share';

import ArtworkPrepare from '../chapter3/artwork-prepare';
import GeneratorElement from '../chapter3/generatorElement';

import '../../styles/chapter3/artwork.scss';

import cover from '../../images/cover_chapter_3.jpg';
import logo from '../../images/MilkyChance_logo_transparent.png';


//import '../chapter3/generator';

class ArtworkGenerator extends React.Component{

	constructor(props){
		super(props);

		this.state ={
			blendOut : false,
			scaleIn : false,
			showIntro : false,
			showGenerator: false,
			showSubmit : false,
			showUpload : false,
			showThankYou : false,
			generatorReady: false,
			email : "",
			generator_title : "",
			wrongEmail : false,
			showPrepare : false,
			showMobileShareMenu : false,
			shareGuid : 0
		}

		this.el = null;

	}

	startGenerator(){

		this.setState({
			showGenerator : true,
			showIntro : false,
			blendOut : false,
			scaleIn : false
		},function(){
			this.props.generatorIsActive();
		});

	}
	
	//___________________________________
	
	generatorReady(){
		this.setState({
			generatorReady : true
		});
	}

	changeTitle(event){
		let title = event.target.value;
		let title_length = title.split('');
		if(title_length.length > 13){
			event.target.className = "generate-share-title too-long-title";
			var el = event.target;
			setTimeout(()=>{
				el.className="generate-share-title";
			},1000);
			title_length.length=13;
			title = title_length.join("");
		}

		this.setState({
			generator_title : title
		});
	}

	prepareCanvas(isMeantToShare, el,cb){
		el.renderer.preserveDrawingBuffer = true;

    el.renderer.setSize(el.config.saveImageSize, el.config.saveImageSize);

    el.renderer.render(el.scene, el.secondcamera);

    //1200x627
   
    var w = el.renderer.domElement.width / window.devicePixelRatio;
    var h = el.renderer.domElement.height / window.devicePixelRatio;
   
    if(isMeantToShare){
    	w = 1200;
    	h = 627;
    }

    var bg_canvas = document.createElement('canvas');
    		bg_canvas.width = w;
    		bg_canvas.height = h;
    		bg_canvas.style.display = "none";
    var bg_c = bg_canvas.getContext('2d');
    var bg_source_image = document.createElement('img');
    		bg_source_image.src = el.canvas.toDataURL("image/png");
    		bg_source_image.onload = ()=>{

    			bg_c.fillStyle= "#b0cfd9";
			    bg_c.fillRect(0,0,w,h);
					
					//not square image for fb share
					if(isMeantToShare){

				    bg_c.drawImage(bg_source_image, w/2 - (h*0.6/2) , h * 0.2, h * 0.6 , h * 0.6 );
				    bg_c.drawImage(this.logo_img,w/2 - (307 / 2) , h * 0.085 , 307 , 24);

					}else{
				    bg_c.drawImage(bg_source_image, w * 0.2 , h * 0.2, w * 0.6 , h * 0.6 );
				    bg_c.drawImage(this.logo_img,w * 0.11 , h * 0.07 , 800 , 60);
					}   



			    let canvas_title = this.state.generator_title != "" ? this.state.generator_title.toUpperCase() : "BLOSSOM";
					let title_length = canvas_title.split('');

					let newCanvasTitle = [];

						title_length.forEach((character,index)=>{
							newCanvasTitle.push(character);
							if(index < title_length.length-1){
								newCanvasTitle.push('   ');
							}
						});

			    bg_c.font = "500 35px Rubik";
			    bg_c.fillStyle = "#fff";
			    bg_c.textAlign = "center";
					bg_c.fillText(newCanvasTitle.join(''),w * .5 , h * 0.91);


					cb(bg_canvas);   
					 
			  	el.renderer.setSize(el.w, el.h);

    		}

    
	}




	downloadGenerator(el){
		this.generator.stopLoop();

		this.setState({
			showPrepare : true
		});
	  el.renderer.preserveDrawingBuffer = true;
		this.prepareCanvas(false,el,(bg_canvas)=>{
			var d = new Promise((resolve,reject)=>{
			var dataURL = bg_canvas.toBlob((blob)=>{
					if(blob != ""){
						resolve(blob);
					}else{
						reject("");
					}
				});
			});

			d.then((blob)=>{
				let title = this.state.generator_title != "" ? "Milky Chance — Blossom Cover — " + this.state.generator_title : "Milky Chance — Blossom Cover";
			  el.convertCanvasToImage(blob,title,()=>{

			  });
			  el.onResize();

			  //update and cancel to stop generator;
				this.generator.update();
        cancelAnimationFrame(this.generator.loop);

				el.renderer.preserveDrawingBuffer = true;
				this.setState({
					showPrepare : false
				});
			}).catch(()=>{
				console.warn('something went wrong');
			});			
		});
	}



	shareGenerator(el){

		this.generator.stopLoop();

		this.prepareCanvas(true,el,(bg_canvas)=>{

			var d = new Promise((resolve,reject)=>{

				var dataURL = bg_canvas.toDataURL("image/jpeg", 1.0);

				if(dataURL != ""){
					resolve(dataURL);
				}else{
					reject("");
				}

			});

			d.then((url)=>{

				let title = this.state.generator_title != "" ? this.state.generator_title : "";
				
				this.saveFacebookImage({
		    	base64 : url,
		    	guid : this.guid(),
		    	title : title
		    },this,(guid)=>{

					/*
						fb communication
					*/
					console.log(guid);

					//if mobile is active
					if(_assets.isMobile){

						this.setState({
							showMobileShareMenu : true,
							shareGuid : guid
						});

					}else{
						FB.ui({
			       	method: 'share',
			       	href: 'http://blossomentary.milkychance.net/chapter3',
			       	picture: _assets.userImageRoot + "/share_images/"+ guid + ".png",
			       	title: "I just created my own MILKY CHANCE - BLOSSOM album cover!",
			       	description: "BLOSSOM the new album of Milky Chance is out March 17th.",
			       	caption: "Milky Chance • A Blossomentary"
			   		}, (response)=> {
				   		this.generator.update();
	        		cancelAnimationFrame(this.generator.loop);
				   	});
					}		    	

		    });//end of cb after upload image

			}).catch(()=>{
				console.warn("something went wrong!");
			});			
			
		});//end of saveFacebookImage
	}

	shareOnFB(){
		FB.ui({
		 	method: 'share',
		 	href: 'http://blossomentary.milkychance.net/chapter3',
		 	picture: _assets.userImageRoot + "/share_images/"+ this.state.shareGuid + ".png",
		 	title: "I just created my own MILKY CHANCE - BLOSSOM album cover!",
		 	description: "BLOSSOM the new album of Milky Chance is out March 17th.",
		 	caption: "Milky Chance • A Blossomentary"
		}, (response)=> {
			this.generator.update();
	   	cancelAnimationFrame(this.generator.loop);

	   	this.setState({
	   		showMobileShareMenu : false
	   	});
		});
	}

	closeSharer(){
		this.setState({
			showMobileShareMenu : false
		});
	}


	submitGenerator(el){

		this.generator.stopLoop();

		this.el = el;
		el.removeEvents();

		this.setState({
			showSubmit : true
		});
	}

	closeSubmit(){
		this.el.addEvents();
		this.setState({
			showSubmit : false
		});
	}

	//__________________________________________________ UPLOAD
	guid() {
	  function s4() {
	    return Math.floor((1 + Math.random()) * 0x10000)
	      .toString(16)
	      .substring(1);
	  }
	  return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
	    s4() + '-' + s4() + s4() + s4();
	}


/*
	Save image for Cover Submission
*/
	saveUserImage(param,that){
		var http = new XMLHttpRequest();
		var url =  _assets.userImageRoot + "/save_user_image.php";

		http.open("POST", url, true);
		http.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
		//http.setRequestHeader("Content-type", "application/json");
		http.onreadystatechange = function() {
			if(http.readyState == 4 && http.status == 200) {
		    that.uploadFinish(true);
		  }
		  if(http.readyState == 4 && http.status == 406) {
		    console.warn('Ouh! Not able to save image!');
		    that.uploadFinish(true);
		  }
		}
		http.send(JSON.stringify(param));
	}

/*
	Save image for FB
*/
	saveFacebookImage(param,that,cb){
		var http = new XMLHttpRequest();
		var url =  _assets.userImageRoot + "/save_fb_image.php";

		http.open("POST", url, true);
		http.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
		//http.setRequestHeader("Content-type", "application/json");
		http.onreadystatechange = function() {
			if(http.readyState == 4 && http.status == 200) {

		    cb(http.responseText);
		    //that.uploadFinish(true);
		  }
		  if(http.readyState == 4 && http.status == 406) {
		    console.warn('Ouh! Not able to save image!');
		    cb(http.responseText);
		  }
		}

		//console.log(params);
		http.send(JSON.stringify(param));
	}

/*
	UPLOAD
*/

	uploadUserGenerator(event){
		event.preventDefault(event);

		if(isEmail(this.state.email)){

			this.setState({
				showUpload : true
			},function(){
				this.el.renderer.preserveDrawingBuffer = true;

		    this.el.renderer.setSize(this.el.config.saveImageSize, this.el.config.saveImageSize);

		    this.el.renderer.render(this.el.scene, this.el.secondcamera);

		    let title = this.state.generator_title != "" ? this.state.generator_title : "";
		    
		    this.saveUserImage({
		    	base64 : this.el.canvas.toDataURL("image/png",1),
		    	guid : this.guid(),
		    	email : this.state.email,
		    	title : title
		    },this);

		    this.el.onResize();
		  });
		}else{
			this.setState({
				email : "",
				wrongEmail : true
			},()=>{
				setTimeout(()=>{
					this.setState({
						wrongEmail : false
					})
				},1000);
			})
		}
	 
	}


	getEmail(event){
		this.setState({
			email : event.target.value
		});
	}

	uploadFinish(success){
		this.setState({
			showThankYou : true
		})
	}
	//__________________________________________________ UPLOAD

	share_custom_facebook_Generator(){
		
	}

	//___________________________________


	componentDidMount(){		
		setTimeout(()=>{
			this.setState({
				scaleIn : true
			},()=>{
				setTimeout(()=>{
					this.setState({
						blendOut : true
					},()=>{
						setTimeout(()=>{
							if(this.generator.isCapable){
								this.setState({
									showIntro : true
								});
							}else{

								this.props.goToInnerChapterByNumber(1);
								
							}

							
						},5000);
					});
				},5000);
			});
		},2500);
	}

	render(){


		const generatorBool = (this.state.showIntro || this.state.showUpload || this.state.showSubmit || this.state.showThankYou); 
		const generatorIsReadyAndVisible = (this.state.generatorReady && this.state.showGenerator);

		return (<div className="artwork-holder">

	
		<ReactCSSTransitionGroup
				component= "div"
				className={"absolute artwork-submit-container intro-container-" +generatorBool}
				transitionName="fade"
				transitionAppear={true}
		    transitionAppearTimeout={500}
				transitionEnterTimeout={500}
				transitionLeaveTimeout={500}>
			
			{/*Intro*/}
				{this.state.showIntro && 
					<ArtworkIntro 
						key="0"
						startGenerator={()=>this.startGenerator()}/>
				}

			
			{/*Submit*/}
				{this.state.showSubmit && 
					<ArtworkSubmit 
						key="1"
						uploadUserGenerator = {(event)=>this.uploadUserGenerator(event)}
						closeSubmit = {(event)=>this.closeSubmit(event)}
						getEmail={(event)=>this.getEmail(event)}
						wrongEmail ={this.state.wrongEmail}
						email ={this.state.email }
						goToInnerChapterByNumber = {(num)=>this.props.goToInnerChapterByNumber(num)}/>
				}
			
			{/*Upload*/}
				{this.state.showUpload && 
						<ArtworkUpload key="2"/>
					}

				{this.state.showPrepare && 
						<ArtworkPrepare key="2a"/>
					}
			
			{/*Thank Your*/}
				{this.state.showThankYou && 
						<ArtworkThanks key="3"
							goToInnerChapterByNumber = {(num)=>this.props.goToInnerChapterByNumber(num)}/>
					}

			{!generatorIsReadyAndVisible && 
				<div key="placeholder" className={"cover-generator-intro blendout-"+this.state.blendOut + " scaleIn-" + this.state.scaleIn }>
					<img src={cover} alt="Cover full bloom" />
				</div>	
			}

		{/*Artwork Placeholder*/}
			<GeneratorElement
				key="realGenerator"
				ref={(generator) =>{this.generator = generator; }}
				goToInnerChapterByNumber = {(num)=>this.props.goToInnerChapterByNumber(num)}
				generatorReady={()=>this.generatorReady()}
				ready={ generatorIsReadyAndVisible }
				shareGenerator={(el)=>this.shareGenerator(el)}
				downloadGenerator={(el)=>this.downloadGenerator(el)}
				generator_title ={this.state.generator_title}
				changeTitle ={(event)=>this.changeTitle(event)}
				share_custom_facebook_Generator={()=>this.share_custom_facebook_Generator()}
				submitGenerator={(el)=>this.submitGenerator(el)} />
			</ReactCSSTransitionGroup>

			{this.state.showMobileShareMenu && 
				<ArtworkMobileShare 
					closeSharer={()=>this.closeSharer()}
					shareOnFB={()=>this.shareOnFB()} />
			}

		{/*Intro Note*/}
			<ReactCSSTransitionGroup
				component= "div"
				className={"absolute inner-note-intro artwork-note-intro-" + (this.state.scaleIn || this.state.blendOut)}
			  transitionName="fade"
			  transitionAppear={true}
     		transitionAppearTimeout={500}
			  transitionEnterTimeout={500}
			  transitionLeaveTimeout={300}>
			  
			  	{this.state.scaleIn && !this.state.blendOut && 
			  		<NoteIntro headline="Full Bloom" />
			  	}

				</ReactCSSTransitionGroup>

				<div className="hidden_logo">
					<img ref={(logo_img)=>{this.logo_img = logo_img}} src={logo} />
				</div>
				{!_assets.isMobile && 
					<audio autoPlay src={_assets.basePath + 'audio/intro_chapter3.mp3'} />
				}
		</div>);
	}
}

export default ArtworkGenerator;


// WEBPACK FOOTER //
// ./src/scripts/chapter3/artwork.js